export const arrayToCsv = (arr: string[]) => arr.join(',');

export const booleanToString = (v: boolean) => String(v);
